<template>
  <slot></slot>
</template>
<script>
import {mapMutations, mapState} from 'vuex';
import headTag from '@/utils/head-tag';

export default {
  name: 'CheckoutContainer',

  props: {
    savedContinueShoppingUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('backend', ['isProduction']),
  },
  created() {
    this.setContinueShoppingUrl(this.savedContinueShoppingUrl);
  },
  async mounted() {
    const GR4VY_FINGERPRINT_URL = this.isProduction
      ? 'https://api.trek.gr4vy.app/f.js'
      : 'https://api.sandbox.trek.gr4vy.app/f.js';
    await headTag.appendAsyncScript('deivce-fingerprints', GR4VY_FINGERPRINT_URL);
  },
  methods: {
    ...mapMutations('checkout', ['setContinueShoppingUrl']),
  },
};
</script>
